export default __webpack_public_path__ + "static/media/noq-gif-3.41ea423c.gif";